import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Verificar si el usuario ya aceptó las cookies
        const consent = localStorage.getItem('cookieConsentAccepted');
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsentAccepted', 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-banner-content">
                <span className="cookie-banner-text">
                    Esta web usa cookies para mejorar tu experiencia. Consulta nuestra{' '}
                    <Link to="/politica-cookies" className="cookie-banner-link">
                        Política
                    </Link>
                    .
                </span>
                <button className="cookie-banner-btn" onClick={handleAccept}>
                    ACEPTAR
                </button>
            </div>
        </div>
    );
}
